import { tick } from 'svelte';

export const writeTextAtCursor = async (text: string) => {
  await tick();
  const selection = window.getSelection();

  const range = selection.getRangeAt(0);
  range.insertNode(document.createTextNode(text));
};

export const moveCursorToEnd = async (el: HTMLElement) => {
  await tick();
  const range = document.createRange();
  const sel = window.getSelection();
  range.selectNodeContents(el);
  range.collapse(false);
  sel.removeAllRanges();
  sel.addRange(range);
};
